<div class="cards-grid grid grid-cols-1 md:grid-cols-2 gap-2 w-full">
  <p-card class="w-full h-full" styleClass="card-col">
    <div class="card-inner flex flex-col justify-between">
      <app-dados-localizacao-demanda
        [showMapa]="true"
        [showTipoObra]="true"
        [mapaAlturaDinamica]="true"
        [tipoObraId]="state.tipoObraId()"
        [dadosLocalizacao]="state.dadosLocalizacao()"
      />
      <div class="flex justify-end shrink-0">
        <p-button
          styleClass="btn-red"
          label="Editar"
          (onClick)="onEditLocalizacao()"
          (keydown.enter)="$event.preventDefault(); onEditLocalizacao()"
          (keydown.space)="$event.preventDefault(); onEditLocalizacao()"
        >
          <app-icon-pencil/>
        </p-button>
      </div>
    </div>
  </p-card>

  <p-card class="w-full h-full" styleClass="card-col">
    <div class="card-inner flex flex-col">
      <div class="card-content flex-1 mb-2">
        <app-form-descricao-demanda [form]="form"/>
      </div>
      <div class="flex justify-end mt-8 shrink-0">
        <p-button styleClass="btn-red" label="Próximo" (onClick)="onSubmit()"
            (keydown.enter)="$event.preventDefault(); onSubmit()"
            (keydown.space)="$event.preventDefault(); onSubmit()">
          <app-icon-bold-arrow-right color="currentColor" size="21"/>
        </p-button>
      </div>
    </div>
  </p-card>
</div>

@if (showOrientacoesUsuarioDialog) {
  <app-dialog
    [(visible)]="showOrientacoesUsuarioDialog"
    [headerTitle]="'Atenção!'"
    width="40vw"
  >
    <div class="flex items-center justify-center px-2">
      Para maior velocidade na análise do pleito, é recomendado o detalhamento
      da descrição, bem como o envio de documentos e projetos que possam
      agilizar o processo de análise e aprovação da demanda.
    </div>
    <div class="flex gap-6" footer>
      <div class="flex justify-end gap-2">
        <p-button
          label="Fechar"
          (onClick)="showOrientacoesUsuarioDialog = false"
          (keydown.enter)="$event.preventDefault(); showOrientacoesUsuarioDialog = false"
          (keydown.space)="$event.preventDefault(); showOrientacoesUsuarioDialog = false"
          styleClass="btn-outlined"
        >
          <app-icon-bold-close-square color="currentColor"></app-icon-bold-close-square>
        </p-button>
      </div>
    </div>
  </app-dialog>
}
